const messages = {
    notificationSettingsTitle: 'Notification Settings',
    notificationSettingsDescription:
        'Manage notification enablement and the stored SMS templates used by the Setting admin APIs.',
    notificationSettingsEnabledSummaryLabel: 'Enabled notifications',
    notificationSettingsTemplateLimitLabel: 'Template character limit',
    notificationSettingsTemplateHelpTitle: 'Template guidance',
    notificationSettingsTemplateHelpBody:
        'Templates are limited to 1000 characters. Placeholder validation is not enforced by the API, so only use tokens supported by the backend flow for each notification.',
    notificationSettingsTemplateStorageHint:
        'Templates remain stored even when a notification is disabled, which lets admins prepare copy before enabling delivery.',
    notificationSettingsReadOnlyNotice:
        'You have view access to notification settings, but only users with update permission can save changes.',
    notificationSettingsLoading: 'Loading notification settings...',
    notificationSettingsLoadFailed: 'Notification settings could not be loaded.',
    notificationSettingsLoadFailedHelp:
        'Retry the request after the API becomes available or after confirming your permissions.',
    notificationSettingsRetryButton: 'Retry',
    notificationSettingsTemplateLabel: 'Message template',
    notificationSettingsTemplatePlaceholder: 'Leave blank to store no template.',
    notificationSettingsTemplateFieldHelp:
        'The backend stores this value as nullable text. Clearing the field removes the saved template.',
    notificationSettingsUnsavedChanges: 'You have unsaved changes.',
    notificationSettingsAllChangesSaved: 'No unsaved changes.',
    notificationSettingsReloadButton: 'Reload from server',
    notificationSettingsSaveButton: 'Save changes',
    notificationSettingsSavingButton: 'Saving...',
    notificationSettingsUpdatedSuccessfully: 'Notification settings updated successfully.',
    notificationSettingsSectionSecurityTitle: 'Security',
    notificationSettingsSectionSecurityDescription:
        'Identity and access notifications that support account verification flows.',
    notificationSettingsSectionAppointmentsTitle: 'Patient appointments',
    notificationSettingsSectionAppointmentsDescription:
        'Patient-facing messages related to confirmations, schedule updates, and visit status.',
    notificationSettingsSectionCustomerServiceTitle: 'Customer service',
    notificationSettingsSectionCustomerServiceDescription:
        'Incidence assignment and resolution notifications for employees and managers.',
    notificationSettingsSectionProvidersTitle: 'Providers and assistants',
    notificationSettingsSectionProvidersDescription:
        'Operational alerts sent to providers and surgeon assistants.',
    notificationSettingsSectionSalesTitle: 'Receipts and payments',
    notificationSettingsSectionSalesDescription:
        'Client receipt and payment-link messages triggered from sales flows.',
    notificationSettingsSectionSalesTeamTitle: 'Sales team',
    notificationSettingsSectionSalesTeamDescription:
        'Seller notifications for lead assignment and appointment cancellation events.',
    notificationSettingsTwoFactorTitle: 'Two-factor code',
    notificationSettingsTwoFactorDescription:
        'Sends the login or verification code required for multi-factor authentication.',
    notificationSettingsClientTransactionReceiptTitle: 'Client transaction receipt',
    notificationSettingsClientTransactionReceiptDescription:
        'Sends a receipt message after transaction-related sales events.',
    notificationSettingsClientQuoteReceiptTitle: 'Client quote receipt',
    notificationSettingsClientQuoteReceiptDescription:
        'Sends quote or invoice receipt details to the client.',
    notificationSettingsPatientAppointmentConfirmTitle: 'Patient appointment confirmation',
    notificationSettingsPatientAppointmentConfirmDescription:
        'Confirms the patient appointment details after scheduling or confirmation flows.',
    notificationSettingsPatientAppointmentCanceledTitle:
        'Patient non-surgical appointment canceled',
    notificationSettingsPatientAppointmentCanceledDescription:
        'Alerts the patient when a non-surgical appointment is canceled.',
    notificationSettingsPatientAppointmentScheduledTitle:
        'Patient non-surgical appointment scheduled',
    notificationSettingsPatientAppointmentScheduledDescription:
        'Alerts the patient when a non-surgical appointment is scheduled.',
    notificationSettingsPatientSurgeryTimeTitle: 'Patient surgical appointment time set',
    notificationSettingsPatientSurgeryTimeDescription:
        'Sends the patient the surgery time once it has been configured.',
    notificationSettingsPatientTurnTitle: 'Patient called to provider',
    notificationSettingsPatientTurnDescription:
        'Alerts the patient when it is their turn to see the doctor.',
    notificationSettingsPatientMassageCompletedTitle: 'Patient massage completed',
    notificationSettingsPatientMassageCompletedDescription:
        'Sends a follow-up SMS after a massage service is completed.',
    notificationSettingsEmployeeAssignedIncidenceTitle: 'Employee assigned to incidence',
    notificationSettingsEmployeeAssignedIncidenceDescription:
        'Notifies the assigned employee when a manager assigns an incidence.',
    notificationSettingsManagerComplaintResolvedTitle: 'Manager complaint resolved',
    notificationSettingsManagerComplaintResolvedDescription:
        'Notifies managers when an employee resolves a complaint or follow-up incidence.',
    notificationSettingsManagerIncentiveResolvedTitle: 'Manager incentive resolved',
    notificationSettingsManagerIncentiveResolvedDescription:
        'Notifies managers when an employee resolves an incentive incidence.',
    notificationSettingsProviderCheckedTitle: 'Provider patient checked in',
    notificationSettingsProviderCheckedDescription:
        'Notifies the provider when a patient is checked in and ready.',
    notificationSettingsProviderCreatedTitle: 'Provider appointment created',
    notificationSettingsProviderCreatedDescription:
        'Notifies the provider when a new non-surgical appointment is created.',
    notificationSettingsSurgeonAssistantCreatedTitle: 'Surgeon assistant appointment created',
    notificationSettingsSurgeonAssistantCreatedDescription:
        'Notifies surgeon assistants when an appointment creation flow requires their attention.',
    notificationSettingsSellerAppointmentCancelledTitle: 'Seller appointment canceled',
    notificationSettingsSellerAppointmentCancelledDescription:
        'Notifies the seller when an appointment tied to their lead is canceled.',
    notificationSettingsSellerNewLeadTitle: 'Seller new lead assigned',
    notificationSettingsSellerNewLeadDescription:
        'Notifies the seller when a new lead is assigned to them.',
    notificationSettingsPatientSharePaymentLinkTitle: 'Patient payment link shared',
    notificationSettingsPatientSharePaymentLinkDescription:
        'Sends the payment link message shared with the patient from sales flows.',
    notificationSettingsSendTestButton: 'Send Test',
    notificationSettingsSendTestTitle: 'Send test notification',
    notificationSettingsSendTestPhoneLabel: 'Phone number',
    notificationSettingsSendTestPhonePlaceholder: '10-digit phone number',
    notificationSettingsSendTestPhoneRequired: 'Phone number is required.',
    notificationSettingsSendTestPhoneInvalid: 'Phone number must be exactly 10 digits.',
    notificationSettingsSendTestHint:
        'The test SMS uses sample placeholder values (e.g. {code} becomes 123456) and is prefixed with [TEST].',
    notificationSettingsSendTestCancelButton: 'Cancel',
    notificationSettingsSendTestSendButton: 'Send',
    notificationSettingsSendTestSendingButton: 'Sending...',
    notificationSettingsSendTestSuccess: 'Test notification sent successfully.',
};

export default messages;
